import { atom, useAtom } from "jotai";
import { Modal } from "@/utils/bootstrap";
import DetectSwipeClose from "./DetectSwipeClose";
import useIsRtl from "@/hooks/useIsRtl";

export const drawerAtom = atom(false);

interface Props {
  children: any;
  reverse?: boolean;
}
const Drawer: React.FC<Props> = ({ children, reverse }) => {
  const [show, setShow] = useAtom(drawerAtom);
  const isRtl = useIsRtl();
  const isReverse = reverse ? !isRtl : isRtl;
  return (
    <DetectSwipeClose
      isRtl={isReverse}
      onClose={() => setShow(false)}
      width={306}
    >
      <Modal
        show={show}
        onHide={() => setShow(false)}
        className={`modal-as-drawer filter fade drawer ${
          isReverse ? "right-align" : "left-align"
        }`}
        style={
          !isReverse
            ? { left: 0, right: "unset" }
            : { left: `calc(100% - 306px)`, right: "unset" }
        }
        dialogClassName="drawer-dialog"
      >
        <div style={{ padding: "24px 16px 30vh 16px" }}> {children}</div>
      </Modal>
    </DetectSwipeClose>
  );
};

export default Drawer;
